import type { FunctionalComponent } from 'preact';
import { useEffect } from 'preact/hooks';
import { env } from '@/lib/env.ts';
import { getInflow } from '@/lib/inflow.ts';
import { exchangeOauth, postOauthResult } from '@/lib/oauth.ts';
import type { PageProps } from '@/types/props.ts';

/**
 * 네이버 로그인 콜백 (팝업 안에서 열린다).
 *
 * 네이버 SDK 는 access_token 을 URL 해시로 넘긴다. 그 토큰을 백엔드에 넘겨
 * 회원 정보를 받고, 결과를 부모창에 postMessage 한 뒤 창을 닫는다.
 */
const OauthNaver: FunctionalComponent<PageProps> = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ''));

    const access_token = params.get('access_token');
    const state = params.get('state');

    if (!access_token || !state) {
      postOauthResult({
        type: 'NAVER_FAIL',
        payload: 'access_token/state 가 없습니다. 콜백 URL 설정을 확인하세요.',
      });
      window.close();
      return;
    }

    void (async () => {
      try {
        const user = await exchangeOauth(env.naver.api, {
          access_token,
          state,
          token_type: params.get('token_type'),
          expires_in: params.get('expires_in'),
          // 광고·제휴 유입 경로. 가입할 때 한 번만 회원 정보에 남는다.
          inflow: getInflow(),
        });

        postOauthResult({ type: 'NAVER_SUCCESS', payload: user });
      } catch (err) {
        postOauthResult({
          type: 'NAVER_FAIL',
          payload: err instanceof Error ? err.message : '네이버 로그인에 실패했습니다.',
        });
      } finally {
        window.close();
      }
    })();
  }, []);

  return <div class="oauth-callback">처리중입니다.</div>;
};

export default OauthNaver;
